import { render } from "./RegistrationOrderItem.vue?vue&type=template&id=916b42f8&scoped=true"
import script from "./RegistrationOrderItem.vue?vue&type=script&lang=js"
export * from "./RegistrationOrderItem.vue?vue&type=script&lang=js"

import "./RegistrationOrderItem.vue?vue&type=style&index=0&id=916b42f8&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\wwwda\\OneDrive\\Desktop\\проекты-и-учебные-файлы-front\\pizzares\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-916b42f8"]])

export default __exports__